import { useState } from "react";
const fechaActual = new Date();
const ejercicioActual = fechaActual.getFullYear();
const mesActual = fechaActual.getMonth() + 1;

const initialStatebox = {
  ejercicioinicio: ejercicioActual,
  ejerciciofin: ejercicioActual,
  periodoinicio: mesActual,
  periodofin: mesActual,
  comparacion: "R",
  titulosucursal: "",
  titulodepartamento: "",
  arrayadr: [],
  arraysucursal: [],
  arraydepartamento: [],
  pv: { adr: [], sucursal: [], departamento: [] },
};
export const useBoxProyecciones = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange, setBoxState];
};

export const useBoxFiltros = (initialState = initialStatebox) => {
  const [boxstate, setBoxState] = useState(initialState);

  const BoxChange = (name, value) => {
    setBoxState({
      ...boxstate,
      [name]: value,
    });
  };

  return [boxstate, BoxChange];
};
